<template>
  <section id="entry" class="section">
    <div class="section__content">
      <div class="wrap">
        <div data-aos="fade-up">
          <div
            class="section__title-img"
            data-aos="fade-up"
            data-aos-delay="800"
          ></div>
          <div class="section__title">
            <span class="span-1 section__span--bold section__span--purple"
              >美股市場</span
            >
            <br class="inactive" />
            <span class="span-2 section__span--bold section__span--purple"
              >將迎來一波新可能
              <div class="shrink">！</div></span
            >
            <br />
            <span class="span-3 section__span--purple"
              >專業團隊帶你搶占先機
              <div class="shrink comma">，</div></span
            ><br class="inactive" />
            <span class="span-4 section__span--purple"
              >投入致勝三分球
              <div class="shrink">！</div></span
            >
          </div>
        </div>

        <div class="table-box table-box-1 table-box--purple" data-aos="fade-up">
          <div class="table-box__item">
            <div class="table-box__title table-box__title--purple">
              定期定額迎向更幸福的未來
            </div>
            <div class="table-box__descript">
              <p>自成立日起，每月定期定額投資本基金至今之累積報酬率走勢</p>
            </div>
            <div class="chart">
              <!-- <div class="tab-content__chart-text">
                自成立日起，每月定期定額投資本基金至今之累積金額走勢
              </div> -->
              <img src="../assets/images/s4_chart-1.png" alt="" />
            </div>
            <div class="secure-text">
              資料來源：Bloomberg，中國信託投信整理，資料期間2016年6月起截至2025年08月底，於每月底進行扣款。採月資料、本基金R/A美元級別。<span
                class="red"
                >投資人因不同時間進場，將有不同之投資績效，過去之績效亦不代表未來績效之保證。此資料僅為歷史數據模擬回測，不為未來投資獲利之保證，在不同指數走勢、比重與期間下，可能得到不同數據結果。</span
              >
            </div>
          </div>
        </div>

        <div
          id="store"
          class="table-box table-box-2 table-box--border table-box--border--purple table-box--purple"
        >
          <div class="table-box__item">
            <div class="table-box__title table-box__title--purple">
              銷售通路
            </div>
            <div class="item">
              <div class="list" v-for="list in lists" :key="list.title">
                <div class="list__title">{{ list.title }}</div>
                <div class="list__content">
                  <p v-for="bank in list.content" :key="bank">{{ bank }}</p>
                </div>
              </div>
            </div>
            <div class="secure-text">
              資料來源：境外基金公開資訊觀測站，中國信託投信整理，以R/A美元級別為主，依筆畫排序，2025/09。
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapActions, mapState } from 'pinia';
import { useMainStore } from '@/store/main';

export default {
  name: 'Entry',
  props: {},
  data: () => {
    return {
      lists: [
        {
          title: '投信投顧',
          content: ['中國信託投信', '法盛投顧', '容海國際投顧'],
        },
        {
          title: '銀行',
          content: [
            '中國信託銀行',
            '王道銀行',
            '台北富邦銀行',
            '永豐銀行',
            '第一銀行',
            '華南銀行',
          ],
        },
        {
          title: '證券',
          content: [
            '元大證券',
            '元富證券',
            '兆豐證券',
            '好好證券',
            '統一證券',
            '富邦證券',
          ],
        },
        {
          title: '基金平台',
          content: ['中租投顧', '基富通證券', '鉅亨買基金'],
        },
      ],
    };
  },
  computed: {
    // ...mapState([])
  },
  methods: {
    // ...mapActions([]),
  },
  mounted() {},
  components: {},
};
</script>

<style lang="scss">
$assets: '~@/assets/images/entry/';

#entry {
  width: 100%;
  max-width: 1920px;
  // height: 2294px;
  background-image: url('../assets/images/s4_bg.jpg');
  background-repeat: repeat-y;
  background-size: 1920px 2293px;
  background-position: center top;
  padding: calc(128px * 0.8) 0 calc(187px * 0.8) 0;
  @include tabletX {
    background-size: vwX(1920) vwX(2293);
    padding: calc(vwX(128) * 0.8) 0 calc(vwX(187) * 0.8) 0;
  }
  @include tablet {
    width: 100%;
    background-image: url('../assets/images/s4_bg_m.jpg');
    background-size: cover;
    padding: vwM(193) 0 vwM(274) 0;
  }
  .section__content {
    .section__title-img {
      width: 481px;
      height: 478px;
      background-image: url('../assets/images/s4_titile_img.png');
      background-size: 481px 478px;
      top: -276px;
      left: 875px;
      z-index: 3;
      @include tabletX {
        width: vwX(481);
        height: vwX(478);
        background-size: vwX(481) vwX(478);
        top: vwX(-276);
        left: vwX(875);
      }
      @include tablet {
        width: vwM(766);
        height: vwM(762);
        background-size: vwM(766) vwM(762);
        top: vwM(-250);
        left: vwM(352);
        z-index: 1;
      }
    }
    .section__title {
      .shrink {
        display: inline-block;
        margin: 0 -22px;
        @include tabletX {
          margin: 0 vwX(-22);
        }
        @include tablet {
          margin: 0 vwX(-30);
        }
      }
      .span-1 {
        padding-right: 0;
        // @include tabletX {
        //   padding-right: vwX(58);
        // }
        @include tablet {
          padding-right: vwM(58);
        }
      }
      .span-2 {
        padding-left: 0;
        // @include tabletX {
        //   padding-left: vwX(58);
        // }
        @include tablet {
          padding-left: vwM(58);
        }
      }
      .span-3 {
        padding-right: 0;
        // @include tabletX {
        //   padding-right: vwX(58);
        // }
        @include tablet {
          padding-right: vwM(76);
        }
        .shrink {
          @include tablet {
            display: none;
          }
        }
      }
      .span-4 {
        padding-left: 10px;
        padding-right: 110px;
        @include tabletX {
          padding-left: vwX(10);
          padding-right: vwX(150);
        }
        @include tablet {
          padding-left: vwM(58);
        }
      }
    }
    .table-box__descript {
      color: #3f3f3f;
      font-weight: 500;
      margin: 16px 0 58px 21px;
      @include tabletX {
        margin: vwX(16) 0 vwX(58) vwX(21);
      }
      @include tablet {
        margin: vwM(25) 0 0 vwM(0);
      }
      // p:nth-child(1) {
      //   font-size: 38px;
      //   letter-spacing: letterSpacing(114, 38px);
      //   @include tabletX {
      //     font-size: vwX(38);
      //     letter-spacing: letterSpacing(114, vwX(38));
      //   }
      //   @include tablet {
      //     font-size: vwM(53);
      //     letter-spacing: letterSpacing(114, vwM(53));
      //   }
      // }
      p:nth-child(1) {
        font-size: 25px;
        line-height: lineHeight(25, 46);
        letter-spacing: letterSpacing(80, 25px);
        margin-top: 67px;
        text-align: center;
        color: #fff;
        background-color: #64117d;
        @include tabletX {
          font-size: vwX(25);
          line-height: lineHeight(25, 46);
          letter-spacing: letterSpacing(80, vwX(25));
          margin-top: vwX(85);
        }
        @include tablet {
          font-size: vwM(25);
          line-height: lineHeight(25, 56);
          letter-spacing: letterSpacing(80, vwM(25));
          margin-top: vwM(85);
          // display: none;
        }
      }
    }
    .table-box-1 {
      margin-top: 16px;
      @include tabletX {
        margin-top: vwX(16);
      }
      @include tablet {
        margin-top: vwM(25);
      }
      .table-box__item {
        padding-bottom: 24px;
        @include tabletX {
          padding-bottom: vwX(24);
        }
        @include tablet {
          padding-bottom: vwM(148);
        }
        .table-box__title::after {
          width: 556px;
          @include tabletX {
            width: vwX(556);
          }
          @include tablet {
            width: 77%;
          }
        }
        .table-box__title {
          margin-bottom: 73px;
          @include tablet {
            margin-bottom: vwM(20);
          }
        }
        .chart {
          @include tablet {
            position: relative;
          }
          .tab-content__chart-text {
            display: none;
            @include tabletX {
              display: none;
              transform: unset;
              top: vwX(77);
              left: 3%;
            }
            @include tablet {
              display: block;
              top: vwM(77);
            }
          }
          img {
            width: 1120px;
            // height: 613px;
            // margin-top: -58px;
            @include tabletX {
              width: vwX(1120);
              // height: vwX(613);
              // margin-top: vwX(-58);
            }
            @include tablet {
              // width: vwM(1544);
              // height: vwM(845);
              width: vwM(885);
              margin-top: vwM(45);
              padding-top: vwM(10);
            }
          }
        }
      }
    }
    .table-box-2 {
      margin-top: vwM(-4);
      .table-box__item {
        padding-bottom: 4px;
        @include tabletX {
          padding-bottom: vwX(4);
        }
        @include tablet {
          padding-bottom: vwM(182);
        }
      }
      .item {
        display: flex;
        justify-content: space-between;
        align-items: normal;
        flex-wrap: wrap;
        width: 1110px;
        margin: 39px auto 0 auto;
        @include tabletX {
          width: vwX(1094);
          margin: vwX(39) auto 0 auto;
        }
        @include tablet {
          width: vwM(830);
          margin: vwM(62) auto 0 auto;
        }
        .list {
          width: 265px;
          height: auto;
          // height: 298px;
          background-color: #f7f3f8;
          padding: 25px 0 13px 25px;
          @include tabletX {
            width: vwX(265);
            // height: auto;
            padding: vwX(25) 0 vwX(13) vwX(25);
          }
          @include tablet {
            width: vwM(403);
            // height: vwM(407);
            padding: vwM(32) 0 vwM(25) vwM(33);
          }

          &:nth-child(1),
          &:nth-child(2) {
            margin-bottom: 0;
            @include tablet {
              margin-bottom: vwM(55);
            }
          }
          .list__title {
            font-size: 29px;
            letter-spacing: letterSpacing(120, 29px);
            color: #64117d;
            @include tabletX {
              font-size: vwX(29);
              letter-spacing: letterSpacing(120, vwX(29));
            }
            @include tablet {
              font-size: vwM(40);
              letter-spacing: letterSpacing(120, vwM(40));
            }
          }
          .list__content {
            font-size: 21px;
            letter-spacing: letterSpacing(80, 21px);
            color: #3f3f3f;
            margin-top: 15px;
            @include tabletX {
              font-size: vwX(21);
              letter-spacing: letterSpacing(80, vwX(21));
              margin-top: vwX(15);
            }
            @include tablet {
              font-size: vwM(30);
              letter-spacing: letterSpacing(80, vwM(30));
              margin-top: vwM(23);
            }
            p {
              margin-bottom: 15px;
              @include tablet {
                margin-bottom: vwM(18);
              }
            }
          }
        }
      }
    }

    .secure-text {
      color: #3f3f3f;
      // font-size: 16.67px;
      // letter-spacing: 0.7px;
      .red {
        color: #64117d;
      }
    }
  }
}
</style>
